export const TABS = {
    ALL: 'ALL',
    SYSTEM: 'SYSTEM',
    MY: 'MY',
}
